import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import {CartEffects} from './cart.effects';
import {cartFeatureKey, reducer} from './cart.reducer';
import {CartItemComponent} from './components/cart-item/cart-item.component';
import {CartSlideComponent} from './components/cart-slide/cart-slide.component';
import {SeFeComponentsModule} from '../../se-fe-components.module';
import {CartCompanionComponent} from './components/cart-companion/cart-companion.component';
import {CheckoutComponent} from 'src/app/common/shopping-cart/components/checkout/checkout.component';

const seFeModules = [SeFeComponentsModule];

const cartComponents = [
  CartSlideComponent,
  CartItemComponent,
  CartCompanionComponent,
  CheckoutComponent,
];

@NgModule({
  declarations: [...cartComponents],
  imports: [
    ...seFeModules,
    CommonModule,
    EffectsModule.forFeature([CartEffects]),
    ReactiveFormsModule,
    StoreModule.forFeature(cartFeatureKey, reducer),
  ],
  exports: [...cartComponents],
})
export class CartModule {}
